import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cuarto-separador',
  templateUrl: './cuarto-separador.component.html',
  styleUrls: ['./cuarto-separador.component.css']
})
export class CuartoSeparadorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
